// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/2da1148a878fde8aa1d1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"38592827d1e7491b9e7d","219":"81896d716e7128e9bd64","220":"66c6a6adbe875723ccaa"}[chunkId] + ".chunk.js";
};